module.exports.init = function (form) {
    const notificationControl = form.getElementsByClassName('notification')[0];
    const clearButton = notificationControl.getElementsByClassName('notification-clear')[0];

    clearButton.onclick = function () {
        notificationControl.classList.remove('notification-success', 'notification-error');
    };
};

module.exports.showSuccess = function (message, notificationControl) {
    notificationControl.classList.remove('notification-error');
    notificationControl.classList.add('notification-success');

    const messageElements = notificationControl.getElementsByClassName('notification-message');
    if (messageElements.length > 0) {
        messageElements[0].innerHTML = message;
    } else {
        notificationControl.innerHTML = message;
    }
};

module.exports.showFailure = function (message, notificationControl) {
    notificationControl.classList.remove('notification-success');
    notificationControl.classList.add('notification-error');

    const messageElements = notificationControl.getElementsByClassName('notification-message');
    if (messageElements.length > 0) {
        messageElements[0].innerHTML = message;
    } else {
        notificationControl.innerHTML = message;
    }
};
